import * as React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import clsx from 'clsx';

import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
  List,
  ListItem,
  ListItemText,
} from '@nelnet/unifi-components-react';

import { SubnavContext } from '../../../providers/SubnavProvider';
import usePageData from '../../../hooks/usePageData';

interface IPropertiesNav {
  path: string;
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    itemSubnav: {
      marginLeft: spacing(7),
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: 0,
        borderLeft: '2px solid #e5e5e5',
      },
      '& a': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
      },
      '& a:hover': {
        backgroundColor: 'transparent',
      },
      '& a span': {
        fontSize: '0.875rem',
        color: '#737373',
        lineHeight: 1.3,
        display: 'block',
      },
      '& a:hover:before': {
        content: '""',
        position: 'absolute',
        top: '.25em',
        bottom: '.25em',
        left: 0,
        borderLeft: `2px solid ${palette.primary.main}`,
      },
    },
    depth1: {
      marginLeft: spacing(5),
    },
  });

const PropertiesNav: React.FunctionComponent<IPropertiesNav> = ({ path }) => {
  const pageData = usePageData({ type: 'single', slug: path });
  const displayNav =
    ['react', 'web'].includes(pageData.type) && !path.includes('layout-validation');
  if (displayNav) {
    return (
      <ListItem
        key={path}
        href="#properties"
        component={(props) => <AnchorLink offset={() => 40} {...props} />}
        className="py-0"
      >
        <ListItemText primary="Properties" />
      </ListItem>
    );
  }
  return null;
};

interface ISubNavHeadingItemProps extends WithStyles<typeof styles> {
  parentDepth?: number;
  parentSlug: string;
}

const SubNavHeadingItem: React.FunctionComponent<ISubNavHeadingItemProps> = ({
  classes,
  parentDepth,
  parentSlug,
}) => {
  const { subnav } = React.useContext(SubnavContext);

  if (subnav !== null && subnav.length) {
    const depthClass = parentDepth === 1 ? classes.depth1 : '';
    return (
      <List className={clsx(classes.itemSubnav, depthClass)} disablePadding key={subnav[0].anchor}>
        {subnav.map(({ anchor, value }) => {
          return (
            <ListItem
              key={anchor}
              href={`#${anchor}`}
              component={(props) => <AnchorLink offset={() => 40} {...props} />}
              className="py-0"
            >
              <ListItemText primary={value} />
            </ListItem>
          );
        })}

        <PropertiesNav path={parentSlug} />
      </List>
    );
  }
  return <></>;
};

export default withStyles(styles)(SubNavHeadingItem);
